import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import S from 'constants/string.const';
import useIsMobileViewport from 'hooks/useIsMobileViewport.hook';
import { useTheme } from 'providers/Theme.provider';

import CN from './ConfirmDeleteFormModal.module.scss';

export const ConfirmDeleteFormModal = ({ isOpen, onClose, onConfirm, onDeactivate, formName, isActive = false }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const isMobile = useIsMobileViewport();

  return (
    <SalonModal
      tag="ConfirmDeleteFormModal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onClose}
      fullWidth={!isMobile}
      mode="dark"
      customClass={cn(CN.modalDialog, { [CN.modalDialogDark]: isDarkMode })}
    >
      <SalonModal.Header>
        <div data-bem="ConfirmDeleteFormModal__header" className={cn(CN.modalHeader, { [CN.darkMode]: isDarkMode })}>
          <Button variant="icon" tag="ConfirmDeleteFormModal__close" className={CN.closeButton} onClick={onClose}>
            <Icon variant="closeDark" width="lg" />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={cn(CN.heading, { [CN.darkMode]: isDarkMode })}>
          <h2 className={CN.title}>{t('consultationForms.deleteModal.title')}</h2>
          {isActive ? (
            <p className={CN.message}>
              {t('consultationForms.deleteModal.message')} <span className={CN.deleteWord}>{t('consultationForms.deleteModal.delete')}</span> &lsquo;<strong>{formName}</strong>&rsquo;.{S.space}
              {t('consultationForms.deleteModal.activeSubMessage')}
            </p>
          ) : (
            <>
              <p className={CN.message}>
                {t('consultationForms.deleteModal.message')} <span className={CN.deleteWord}>{t('consultationForms.deleteModal.delete')}</span> <strong>&lsquo;{formName}&rsquo;</strong>?
              </p>
              <p className={CN.subMessage}>{t('consultationForms.deleteModal.subMessage')}</p>
            </>
          )}
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        {isActive ? (
          <Button variant="tertiary" onClick={onDeactivate} tag="ConfirmDeleteFormModal__deactivate">
            {t('consultationForms.deleteModal.deactivate')}
          </Button>
        ) : (
          <Button variant="tertiary" onClick={onClose} tag="ConfirmDeleteFormModal__cancel">
            {t('consultationForms.cancel')}
          </Button>
        )}
        <Button variant="alert" onClick={onConfirm} tag="ConfirmDeleteFormModal__confirm">
          {t('consultationForms.deleteModal.confirm')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};
